import React, { useState, useCallback, useEffect, useContext } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  ButtonBase,
  InputLabel,
  InputAdornment,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import clienteAxios from "../../../config/axios";
import MessageSnackbar from "../../../components/Snackbar/snackbar";
import Spin from "../../../components/Spin/spin";
import { useDropzone } from "react-dropzone";
import CambiarPassword from "./password";
import { NavContext } from "../../../context/context_nav";
import { jwtDecode } from "jwt-decode";
import "./inputs.css";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DateRangeIcon from "@mui/icons-material/DateRange";
import Done from "@mui/icons-material/Done";
import FaceIcon from "@mui/icons-material/Face";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SchoolIcon from "@mui/icons-material/School";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { useNavigate } from "react-router-dom";

export default function PerfilUsuario(props) {
  const navigate = useNavigate();
  let token = localStorage.getItem("token");
  const [datos, setDatos] = useState([]);
  const [preview, setPreview] = useState(null);
  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [controlImagen, setControlImagen] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    mensaje: "",
    status: "",
  });
  const { update, setUpdate } = useContext(NavContext);
  let user = { _id: "" };

  if (!token || !user) navigate("/");

  if (token !== null) user = JSON.parse(localStorage.getItem("student"));

  const onDrop = useCallback(
    (files) => {
      setControlImagen(true);
      setPreview(URL.createObjectURL(files[0]));
      setDatos({
        ...datos,
        urlImage: files[0],
      });
    },
    [datos],
  );
  const { getRootProps, getInputProps /* isDragActive */ } = useDropzone({
    onDrop,
  });

  const obtenerCampos = (e) => {
    setDatos({
      ...datos,
      [e.target.name]: e.target.value,
    });
  };

  const obtenerDatosBD = useCallback(async () => {
    if (!user?._id) return;
    setLoading(true);
    await clienteAxios
      .get(`/user/${user?._id}`, {
        headers: {
          Authorization: `bearer ${token}`,
        },
      })
      .then((res) => {
        setLoading(false);
        setDatos(res.data);
        setPreview(res.data.urlImage);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          setSnackbar({
            open: true,
            mensaje: err.response.data.message,
            status: "error",
          });
        } else {
          setSnackbar({
            open: true,
            mensaje: "Al parecer no se a podido conectar al servidor.",
            status: "error",
          });
        }
      });
  }, [token, user?._id]);

  const guardarDatosBD = async () => {
    if (!datos.name) {
      setValidate(true);
      return;
    }
    const formData = new FormData();
    for (const key in datos) {
      if (Object.hasOwnProperty.call(datos, key)) {
        const element = datos[key];
        if (key === "urlImage") {
          if (controlImagen) {
            formData.append("imagen", element);
          }
        } else if (key !== "password" && key !== "keyImage") {
          formData.append(key, element);
        }
      }
    }

    setLoading(true);
    await clienteAxios
      .put(`/user/${user?._id}`, formData, {
        headers: {
          Authorization: `bearer ${token}`,
        },
      })
      .then((res) => {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem(
          "student",
          JSON.stringify(jwtDecode(res.data.token)),
        );
        setLoading(false);
        setSnackbar({
          open: true,
          mensaje: "Guardado correctamente",
          status: "success",
        });
        setUpdate(!update);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          setSnackbar({
            open: true,
            mensaje: err.response.data.message,
            status: "error",
          });
        } else {
          setSnackbar({
            open: true,
            mensaje: "Al parecer no se a podido conectar al servidor.",
            status: "error",
          });
        }
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    obtenerDatosBD();
  }, [obtenerDatosBD]);

  return (
    <Container>
      <Spin loading={loading} />
      <MessageSnackbar
        open={snackbar.open}
        mensaje={snackbar.mensaje}
        status={snackbar.status}
        setSnackbar={setSnackbar}
      />
      <CambiarPassword
        openModal={openModal}
        setOpenModal={setOpenModal}
        user={user}
        token={token}
      />
      <Box
        display="flex"
        alignItems="center"
        mt={2}
        sx={{ flexDirection: "column" }}
      >
        <Container maxWidth="sm">
          <Box display="flex" justifyContent="center">
            <Box
              mb={2}
              display="flex"
              justifyContent="center"
              alignItems="flex-end"
              {...getRootProps()}
            >
              <ButtonBase
                focusRipple
                sx={{
                  position: "relative",
                  height: 120,
                  width: 120,
                  "&:hover": {
                    zIndex: 1,
                    "& .MuiImageBackdrop": {
                      opacity: 0.6,
                    },
                    "& .MuiImageEditButton": {
                      display: "block",
                    },
                  },
                }}
              >
                <input {...getInputProps()} name="urlImage" />
                {datos.urlImage ? (
                  <span
                    style={{
                      backgroundImage: preview ? `url(${preview})` : ``,
                      position: "absolute",
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                      backgroundSize: "cover",
                      backgroundPosition: "center 40%",
                      borderRadius: "5%",
                    }}
                  />
                ) : (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                      backgroundSize: "cover",
                      backgroundPosition: "center 40%",
                      borderRadius: "5%",
                    }}
                  >
                    <AccountBoxIcon style={{ fontSize: 100, opacity: 0.5 }} />
                  </Box>
                )}

                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: (theme) => theme.palette.common.black,
                    opacity: 0,
                    transition: (theme) => theme.transitions.create("opacity"),
                    borderRadius: "5%",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: (theme) => theme.palette.common.white,
                    cursor: "pointer",
                  }}
                >
                  <Grid container direction="column">
                    <Typography
                      component="span"
                      variant="subtitle1"
                      color="inherit"
                      sx={{
                        display: "none",
                      }}
                    >
                      <CameraAltIcon style={{ fontSize: 60, opacity: 0.7 }} />
                    </Typography>
                    {/* <Typography
                      component="span"
                      color="inherit"
                      sx={{
                        display: "none",
                      }}
                    >
                      {isDragActive ? (
                        <Typography>Suelta tu archivo aquí ...</Typography>
                      ) : (
                        <Typography>
                          Arrastra y suelta un archivo o selecciona uno haciendo
                          click
                        </Typography>
                      )}
                    </Typography> */}
                  </Grid>
                </span>
              </ButtonBase>
            </Box>
          </Box>
          <TextField
            error={validate && !datos.name}
            id="name"
            name="name"
            label="Nombre"
            placeholder="Nombre"
            fullWidth
            variant="outlined"
            value={datos.name ? datos.name : ""}
            onChange={obtenerCampos}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FaceIcon />
                </InputAdornment>
              ),
            }}
            margin="dense"
            sx={{
              backgroundColor: (theme) => theme.palette.background.paper,
            }}
          />
          <TextField
            id="age"
            name="age"
            label="Edad"
            placeholder="Edad"
            type="number"
            fullWidth
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <DateRangeIcon />
                </InputAdornment>
              ),
              inputProps: { min: 0 },
            }}
            margin="dense"
            value={datos.age ? datos.age : ""}
            onChange={obtenerCampos}
            sx={{
              backgroundColor: (theme) => theme.palette.background.paper,
            }}
          />
          <FormControl
            variant="outlined"
            fullWidth
            margin="dense"
            sx={{
              backgroundColor: (theme) => theme.palette.background.paper,
            }}
          >
            <InputLabel id="label-escolaridad">Escolaridad</InputLabel>
            <Select
              fullWidth
              labelId="label-escolaridad"
              label="Escolaridad"
              id="scholarship"
              name="scholarship"
              onChange={obtenerCampos}
              value={datos.scholarship ? datos.scholarship : ""}
              renderValue={(value) => value}
              startAdornment={
                <InputAdornment position="start">
                  <SchoolIcon />
                </InputAdornment>
              }
            >
              <MenuItem value="">
                <em>Ninguna</em>
              </MenuItem>
              <MenuItem value="Educación Primaria">Educación Primaria</MenuItem>
              <MenuItem value="Educación secundaria">
                Educación secundaria
              </MenuItem>
              <MenuItem value="Educación media superior o bachillerato">
                Educación media superior o bachillerato
              </MenuItem>
              <MenuItem value="Educación media superior, técnico superior, licenciatura o postgrado">
                Educación media superior, técnico superior, licenciatura o
                postgrado
              </MenuItem>
            </Select>
          </FormControl>
          <TextField
            /* className="no-spin" */
            id="phone"
            name="phone"
            label="Telefono"
            placeholder="Telefono"
            type="number"
            fullWidth
            variant="outlined"
            value={datos.phone ? datos.phone : ""}
            onChange={obtenerCampos}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PhoneIphoneIcon />
                </InputAdornment>
              ),
            }}
            margin="dense"
            sx={{
              backgroundColor: (theme) => theme.palette.background.paper,
            }}
            className="no-spin"
          />
          <TextField
            id="email"
            name="email"
            label="Correo electrónico"
            placeholder="Correo electrónico"
            fullWidth
            variant="outlined"
            value={datos.email ? datos.email : ""}
            onChange={obtenerCampos}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MailOutlineIcon />
                </InputAdornment>
              ),
            }}
            margin="dense"
            disabled
            sx={{
              backgroundColor: (theme) => theme.palette.background.paper,
            }}
          />
          <TextField
            id="profession"
            name="profession"
            label="Profesión"
            fullWidth
            variant="outlined"
            placeholder="Ejemplo: Ingeniero, maestro en diseño grafico, desarrollador web"
            value={datos.profession ? datos.profession : ""}
            onChange={obtenerCampos}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <WorkOutlineIcon />
                </InputAdornment>
              ),
            }}
            margin="dense"
            sx={{
              backgroundColor: (theme) => theme.palette.background.paper,
            }}
          />
          {user && user.sessiontype !== "ApiRest" ? null : (
            <Box my={2}>
              <Button
                color="primary"
                variant="text"
                onClick={() => setOpenModal(true)}
              >
                Cambiar tu contraseña
              </Button>
            </Box>
          )}

          <Box
            display="flex"
            my={2}
            sx={{
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              aria-label="Guardar"
              onClick={() => guardarDatosBD()}
              startIcon={<Done />}
            >
              Guardar
            </Button>
          </Box>
        </Container>
      </Box>
    </Container>
  );
}
